import { FC } from 'react';
import { DESCRIPTION_SPACE, PART_SEPARATOR, TRUNCATION_ELLIPSIS } from './model/filtersDescription';

/** Пропсы разделителя частей описания отбора */
type Props = {
  /** Хвост обрыва: за разделителем стоит многоточие ушедших из строки частей */
  isClipped?: boolean;
  testId?: string;
};

/** Разделитель между частями описания отбора; он же отмечает обрыв описания по правому краю */
export const FiltersDescriptionSeparator: FC<Props> = ({ isClipped = false, testId }) => (
  <span className="shrink-0" data-testid={testId}>
    {PART_SEPARATOR}
    {DESCRIPTION_SPACE}
    {isClipped ? TRUNCATION_ELLIPSIS : null}
  </span>
);
